<template>
  <div class="worktime-box">
    <WorkTime
      v-for="(w, i) of value"
      :value="w"
      @input="(v) => patchValue(v, i)"
      :key="i"
    />
    <button
      class="el-button el-button--primary el-button--small"
      @click="setEmpty"
      type="button"
    >
      +
    </button>
  </div>
</template>

<script>
import WorkTime from "./WorkTime.vue";

export default {
  components: { WorkTime },
  props: {
    value: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    patchValue(newValue, i) {
      const newArray = this.value.reduce((arr, next, idx) => {
        if (i === idx) next = newValue;
        arr.push(next);
        return arr;
      }, []);

      this.$emit("input", newArray);
    },
    setEmpty() {
      this.$emit("input", [
        ...this.value,
        {
          day: "",
          open: "",
          close: "",
        },
      ]);
    },
  },
};
</script>
